import React, { useState, useEffect, useContext } from 'react';
import { PassengerAPI } from '../../../../../../../API/PassengerAPIs/PassengerAPIs';
import STC from '../../../../../../../STCLibrary/STCFactory/STCFactory';
import ViewTourTableInfo from './ViewTourTableInfo/ViewTourTableInfo';
import ViewTourInfo from './ViewTourInfo/ViewTourInfo';
import './ViewPassengerTour.css'
import PassengerForm from '../../PassengerForm/PassengerForm';
import ApiResponseHandler from '../../../../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';
import { useNavigate } from 'react-router-dom';
import NotificationContext from '../../../../../../../STCLibrary/NotificationSystem/NotificationContext';

export default function ViewPassengerTours({passenger}){

    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);

    const [loading, setLoading] = useState(true);
    const [addNew, setAddNew] = useState(false);
    const [showCompleted, setShowCompleted] = useState(false);
    const [tourList, setTourList] = useState([]);
    const [selectedTour, setSelectedTour] = useState(null);
    const ColumnHeaders = ['Destination', 'B-ID', 'DOT', '']



    const thData = () => {
        return ColumnHeaders.map((title, index) => {
            return(
                <th className="column-title" key={index}>{title}</th>
            )
        })
    }

    const tdData = () => {
        return tourList.map((tourId) => {
            return(<ViewTourTableInfo key={tourId} tourID={tourId} selectedTour={selectedTour} setSelectedTour={setSelectedTour} showCompleted={showCompleted} passenger={passenger}/>)
        })
    }

    const getPassengerTours = () => {
        PassengerAPI.GetPassengersTours(passenger.id)
        .then((response) => {
            if(response.status === 200){
                setTourList(response.data.reverse());
                setLoading(false);
            }
        })
        .catch((err) => {
            console.log(err);
            ApiResponseHandler(err.response, notificationCtx, navigate)
        })

    }

    const handleSuccess = () => {
        setAddNew(false);
        getPassengerTours();
    }

    const handleShowCompletedTours = () => {
        setShowCompleted(!showCompleted);
    }

    

    useEffect(() => {
        getPassengerTours();
    }, [])

    return(
        <div>
            <div>
                <div className='add-tour-button-line'>
                    <STC.Button className={addNew ? 'cancel' : ''} onClick={() => setAddNew(!addNew)}>{addNew ?  'Cancel' : 'Add Tour - ' + passenger.firstName + ' ' + passenger.surname}</STC.Button>
                </div>
                {addNew && 
                <div className='m-2'>
                    <div><PassengerForm passenger={passenger} handleSuccess={handleSuccess}/></div>
                </div>
                }
                <div align={'end'} className='completed-tours-option' onClick={handleShowCompletedTours}>{showCompleted ? 'Hide':'Show'} Completed Tours</div>
                {/* <STC.Table size={'sm'} responsive>
                    <thead>
                        <tr >{thData()}</tr>
                    </thead>
                    <tbody  className="column-data">
                        {tdData()}
                    </tbody>
                </STC.Table>     */}

                
                    {tdData()}
            </div>
            

        
            {/* <div>
            {loading ? "Loading..."  :
            ((tourList.length > 0 && selectedTour) ?  
            <ViewTourInfo passenger={passenger} tour={selectedTour}/>
            : 
            'Please select a tour from above to view full details or make a payment')}
            </div> */}
            
            <div>
            {loading ? "Loading..."  :
            (!(tourList.length > 0 && selectedTour) && 
            
            'Please select a tour from above to view full details or make a payment')}
            </div>
            
        </div>
    )
}